/**
 * Paper.js
 * Base component for showing depth
 *
 * @class  Paper
 * @author  Randy Lebeau
 * @author  Yevgeniy Rokhlin
 *
 */

import React from 'react';
import ClassNames from 'classnames';

export default React.createClass({



	propTypes: {
		circle: React.PropTypes.bool,
		className: React.PropTypes.string,
		innerClassName: React.PropTypes.string,
		rounded: React.PropTypes.bool,
		depth: React.PropTypes.oneOf([0, 1, 2, 3, 4, 5]),
		padded: React.PropTypes.bool,
		overflow: React.PropTypes.bool,
		topRounded: React.PropTypes.bool,
		bottomRounded: React.PropTypes.bool,
		leftRounded: React.PropTypes.bool,
		rightRounded: React.PropTypes.bool,
		healLeft: React.PropTypes.bool,
		healRight: React.PropTypes.bool,
		healTop: React.PropTypes.bool,
		healBottom: React.PropTypes.bool

	},

	getDefaultProps() {
		return {
			className: '',
			innerClassName: '',
			circle: false,
			rounded: false,
			depth: 1,
			overflow: true,
			padded: false,
			topRounded: false,
			bottomRounded: false,
			leftRounded: false,
			rightRounded: false,
			fullWidth: false,
			fullHeight: false,
			healLeft: false,
			healRight: false,
			healTop: false,
			healBottom: false
		};
	},

	render() {
		let {
			rounded,
			depth,
			className,
			innerClassName,
			topRounded,
			bottomRounded,
			leftRounded,
			rightRounded,
			circle,
			padded,
			overflow,
			fullWidth,
			fullHeight } = this.props;

		let paperClasses = ClassNames(
			'lui-paper',
			`lui-paper-z-depth-${depth}`,
			className,
			{
				'lui-paper-rounded': rounded,
				'lui-paper-top-rounded': topRounded,
				'lui-paper-bottom-rounded': bottomRounded,
				'lui-paper-left-rounded': leftRounded,
				'lui-paper-right-rounded': rightRounded,
				'lui-paper-circle': circle,
				'lui-paper-padded': padded,
				'lui-paper-overflow': !overflow, // Turn on for false
				'lui-paper-full-width': fullWidth,
				'lui-paper-full-height': fullHeight
			}),
			insideClasses = ClassNames(
				innerClassName,
				'lui-paper-container',
				'lui-paper-z-depth-bottom'
				),
			healWrapperClasses = ClassNames(
				`lui-paper-z-depth-${depth}`,
				'lui-paper-heal-wrapper',{
				'lui-heal-left' : this.props.healLeft,
				'lui-heal-right' : this.props.healRight,
				'lui-heal-top' : this.props.healTop,
				'lui-heal-bottom' : this.props.healBottom
			});


		let paper;

		if (this.props.healLeft || this.props.healRight || this.props.healTop || this.props.healBottom ) {
			paper = (			
				<div className={healWrapperClasses}>
					<div className={paperClasses} style={this.props.style}>
						<div ref="innerContainer" className={insideClasses}>
							{this.props.children}
						</div>
					</div>
				</div>
			);
		} else {
			paper = (
				<div className={paperClasses} style={this.props.style}>
					<div ref="innerContainer" className={insideClasses}>
						{this.props.children}
					</div>
				</div>
			); 
		}

		return (paper);
	},

	getInnerContainer() {
		return this.refs.innerContainer;
	}
});



/** WEBPACK FOOTER **
 ** ./src/components/paper/Paper.js
 **/